<template>
  <a-layout-sider class="sider" width="273">
    <setting-item title="整体风格设置">
      <img-checkbox-group @change="setTheme">
        <img-checkbox
          img="https://gw.alipayobjects.com/zos/rmsportal/LCkqqYNmvBEbokSDscrm.svg"
          :checked="true"
          value="dark"
        />
        <img-checkbox
          img="https://gw.alipayobjects.com/zos/rmsportal/jpRkZQMyYRryryPNtyIC.svg"
          value="light"
        />
      </img-checkbox-group>
    </setting-item>
    <a-divider />
    <setting-item title="导航设置">
      <img-checkbox-group @change="setLayout">
        <img-checkbox
          img="https://gw.alipayobjects.com/zos/rmsportal/JopDzEhOqwOjeNTXkoje.svg"
          :checked="true"
          value="side"
        />
        <img-checkbox
          img="https://gw.alipayobjects.com/zos/rmsportal/KDNDBbriJhLwuqMoxcAr.svg"
          value="head"
        />
      </img-checkbox-group>
    </setting-item>
    <setting-item>
      <a-list :split="false">
        <a-list-item
          >固定Header
          <a-switch
            slot="actions"
            :checked="fixedHeader"
            size="small"
            @change="setFixedHeader"
          />
        </a-list-item>
        <a-list-item
          >固定Siderbar
          <a-switch
            slot="actions"
            :checked="fixedSider"
            size="small"
            @change="setFixedSider"
          />
        </a-list-item>
      </a-list>
    </setting-item>
    <a-divider />
    <setting-item title="其他设置">
      <a-list :split="false">
        <a-list-item
          >多页签模式
          <a-switch
            slot="actions"
            size="small"
            :checked="multipage"
            @change="setMultipage"
          />
        </a-list-item>
      </a-list>
    </setting-item>
  </a-layout-sider>
</template>

<script>
import SettingItem from './SettingItem';
import StyleItem from './StyleItem';
import ImgCheckbox from '../checkbox/ImgCheckbox';
import { mapState } from 'vuex';
const ImgCheckboxGroup = ImgCheckbox.Group;

export default {
  name: 'Setting',
  components: {
    ImgCheckboxGroup,
    ImgCheckbox,
    StyleItem,
    SettingItem
  },

  computed: mapState({
    fixedSider: state => state.setting.fixedSider,
    fixedHeader: state => state.setting.fixedHeader,
    multipage: state => state.setting.multipage
  }),

  methods: {
    onColorChange(values, colors) {
      if (colors.length > 0) {
        this.$message.info(`您选择了主题色 ${colors}`);
      }
    },
    setTheme(values) {
      this.$store.commit('setting/setTheme', values[0]);
    },
    setLayout(values) {
      this.$store.commit('setting/setLayout', values[0]);
    },

    // copyCode() {
    //   let clipboard = new Clipboard('#copyBtn');
    //   const _this = this;
    //   clipboard.on('success', function() {
    //     _this.$message.success(`复制成功`);
    //     clipboard.destroy();
    //   });
    // },

    setFixedSider(checked) {
      this.$store.commit('setting/setFixedSider', checked);
    },

    setFixedHeader(checked) {
      this.$store.commit('setting/setFixedHeader', checked);
    },

    setMultipage(checked) {
      this.$store.commit('setting/setMultipage', checked);
    }
  }
};
</script>

<style lang="stylus" scoped>
.sider
  background-color #fff
  height 100%
  padding 24px
  font-size 14px
  line-height 1.5
  word-wrap break-word
  position relative
  .flex
    display flex
</style>
